import { buildProps } from '@jdesign-vue/utils'
import type { ExtractPropTypes } from 'vue'

export const emptyProps = buildProps({
  /**
   * @description image URL of empty
   */
  image: {
    type: String,
    default: '',
  },
  /**
   * @description image size (width) of empty
   */
  imageSize: {
    type: Number,
    default: 120,
  },
  /**
   * @description description of empty
   */
  description: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    values: [
      'data',
      'news',
      'network',
      'permission',
      'search',
      'server',
      'browser',
    ],
    default: 'data',
  },
} as const)

export type EmptyProps = ExtractPropTypes<typeof emptyProps>
